import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { CoerceoHeuristic } from './CoerceoHeuristic';
export class CoerceoPiecesTilesFreedomHeuristic extends CoerceoHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        const metrics = PlayerNumberTable.of([0, 0, 0], [0, 0, 0]);
        const pieceMap = this.getPiecesMap(state);
        const piecesScores = this.getPiecesFreedomScore(state);
        const pieceIndex = 0;
        const tilesIndex = 1;
        const freedomIndex = 2;
        for (const owner of Player.PLAYERS) {
            const playerPieces = pieceMap.get(owner).get();
            metrics.add(owner, pieceIndex, playerPieces.size());
            metrics.add(owner, tilesIndex, state.tiles.get(owner));
            metrics.add(owner, freedomIndex, piecesScores[owner.getValue()]);
        }
        return metrics;
    }
}
